import { FC } from 'react';
import { styled } from '@mui/material/styles';

interface RentalsIconProps {
  size?: number | string;
  color?: string;
}

const StyledSvg = styled('svg')({});

const RentalsIcon: FC<RentalsIconProps> = ({
  size = 24,
  color = 'currentColor',
}) => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 84.18 71.19"
    width={size}
    height={size}
    fill={color}
  >
    <path
      className="cls-1"
      d="M63,47.57h-7.88v-3.97c-1.26.2-2.53.31-3.81.31-1.38,0-2.74-.12-4.06-.34v4.01h-7.88v-6.79c-3.78-2.13-6.95-5.23-9.15-8.96h-6.6v-7.88h3.65c-.27-1.46-.42-2.96-.42-4.5,0-1.15.09-2.27.24-3.37h-3.46v-7.88h5.98c1.59-3.06,3.81-5.74,6.49-7.88H15.75v15.75H0v55.12h31.5v-15.75h7.88v15.75h31.5v-20.62l-7.88-7.86v4.86ZM15.75,63.32h-7.88v-7.88h7.88v7.88ZM15.75,47.57h-7.88v-7.88h7.88v7.88ZM15.75,31.82h-7.88v-7.88h7.88v7.88ZM31.5,47.57h-7.88v-7.88h7.88v7.88ZM63,63.32h-7.88v-7.88h7.88v7.88Z"
    />
    <path
      className="cls-1"
      d="M69.26,32.9h-2.36l-.84-.81c2.93-3.41,4.7-7.84,4.7-12.65,0-10.74-8.7-19.44-19.44-19.44s-19.44,8.7-19.44,19.44,8.7,19.44,19.44,19.44c4.82,0,9.24-1.76,12.65-4.7l.81.84v2.36l14.95,14.93,4.46-4.46-14.92-14.95ZM51.31,32.9c-7.45,0-13.46-6.01-13.46-13.46s6.01-13.46,13.46-13.46,13.46,6.01,13.46,13.46-6.01,13.46-13.46,13.46Z"
    />
  </StyledSvg>
);

export default RentalsIcon;
